import API from "../../../app/api";

export const globalSearch = async (keywords) => {
  try {
    const response = await API.get("/search", {
      params: {
        search: keywords,
      },
    });

    console.log("Global Search Response:", response?.data);

    return response?.data;
  } catch (error) {
    console.error(
      "Global Search API Error:",
      error?.response?.data || error?.message
    );

    throw error;
  }
};